// extracted by mini-css-extract-plugin
module.exports = {"container":"TextContainer_container__1LWha","content":"TextContainer_content__329VR"};